import { Check as CheckIcon } from 'components/icons';
import { Tooltip } from 'components/ui/tooltip';
import { MinDto } from 'types/other';

export default function StepDate({ date, changedByEmployee }: { date: string; changedByEmployee?: MinDto | null }) {
    const text = (
        <p className="text-fg flex cursor-default items-center gap-[0.5ch] self-center text-xs whitespace-nowrap opacity-40">
            <CheckIcon className="h-[auto] w-[11px]" />
            {date}
        </p>
    );
    return changedByEmployee?.name ? <Tooltip content={changedByEmployee.name}>{text}</Tooltip> : text;
}
